<div class="work-interval">
  <div class="grid grid--gap-4">
    <div class="grid__box grid__box--size-6">
      <div *ngIf="intervals['moved-time'] && (intervals['moved-time'].hours || intervals['moved-time'].minutes)">
        <div class="grid grid--gap-4 grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <div
              title="{{ Enums.workShiftTicketsIntervalMap[3] }}"
              class="cur-help work-shift-interval-square {{ 'work-shift-interval-square--' + Enums.workShiftTicketsIntervalSquare[3] }}"
            ></div>
          </div>
          <div class="grid__box grid__box--size-min">
            <span *ngIf="intervals['moved-time'].hours">{{ intervals['moved-time'].hours }}ч </span>
            <span *ngIf="intervals['moved-time'].minutes">{{ intervals['moved-time'].minutes }} м</span>
          </div>
        </div>
      </div>
    </div>
    <div class="grid__box grid__box--size-6">
      <div *ngIf="intervals['work-time'] && (intervals['work-time'].hours || intervals['work-time'].minutes)">
        <div class="grid grid--gap-4 grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <div
              title="{{ Enums.workShiftTicketsIntervalMap[7] }}"
              class="cur-help work-shift-interval-square {{ 'work-shift-interval-square--' + Enums.workShiftTicketsIntervalSquare[7] }}"
            ></div>
          </div>
          <div class="grid__box grid__box--size-min">
            <span *ngIf="intervals['work-time'].hours">{{ intervals['work-time'].hours }}ч </span>
            <span *ngIf="intervals['work-time'].minutes">{{ intervals['work-time'].minutes }}м</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
